//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function getMySettingsUrl(): string {
  let url_ = getBaseUrl() + "/api/user-settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMySettingsDefaultOptions: Omit<UseQueryOptions<Types.UserSettingsDto, unknown, Types.UserSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserSettingsDto, unknown, Types.UserSettingsDto>, 'queryFn'>> = {
};
export function getGetMySettingsDefaultOptions() {
  return getMySettingsDefaultOptions;
};
export function setGetMySettingsDefaultOptions(options: typeof getMySettingsDefaultOptions) {
  getMySettingsDefaultOptions = options;
}

export function getMySettingsQueryKey(): QueryKey;
export function getMySettingsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserSettingsClient',
      'getMySettings',
    ]);
}
export function __getMySettings(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMySettings(
axiosConfig    );
}

/**
 * Returns user's settings.
 */
export function useGetMySettingsQuery<TSelectData = Types.UserSettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.UserSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMySettingsQuery<TSelectData = Types.UserSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMySettings(context, axiosConfig) : __getMySettings,
    queryKey: getMySettingsQueryKey(),
    ...getMySettingsDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns user's settings.
 */
export function setGetMySettingsData(queryClient: QueryClient, updater: (data: Types.UserSettingsDto | undefined) => Types.UserSettingsDto, ) {
  queryClient.setQueryData(getMySettingsQueryKey(),
    updater
  );
}

/**
 * Returns user's settings.
 */
export function setGetMySettingsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserSettingsDto | undefined) => Types.UserSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function toggleInventoryMaterialsOnlyUrl(): string {
  let url_ = getBaseUrl() + "/api/user-settings/toggle-inventory-materials-only";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function toggleInventoryMaterialsOnlyMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserSettingsClient',
      'toggleInventoryMaterialsOnly',
    ]);
}

/**
 * Toggles ShowMoreCoefficients.
 */
export function useToggleInventoryMaterialsOnlyMutation<TContext>(options?: Omit<UseMutationOptions<boolean, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, void, TContext> {
  const key = toggleInventoryMaterialsOnlyMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.toggleInventoryMaterialsOnly(),
    mutationKey: key,
  });
}
  
export function toggleShowMoreCoefficientsUrl(): string {
  let url_ = getBaseUrl() + "/api/user-settings/toggle-more-coefficients";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function toggleShowMoreCoefficientsMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserSettingsClient',
      'toggleShowMoreCoefficients',
    ]);
}

/**
 * Toggles InventoryMaterialsOnly.
 */
export function useToggleShowMoreCoefficientsMutation<TContext>(options?: Omit<UseMutationOptions<boolean, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, void, TContext> {
  const key = toggleShowMoreCoefficientsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.toggleShowMoreCoefficients(),
    mutationKey: key,
  });
}
  
export function toggleEnableObsidianIntegrationUrl(): string {
  let url_ = getBaseUrl() + "/api/user-settings/toggle-enable-obsidian-integration";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function toggleEnableObsidianIntegrationMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserSettingsClient',
      'toggleEnableObsidianIntegration',
    ]);
}

/**
 * Toggles EnableObsidianIntegration.
 */
export function useToggleEnableObsidianIntegrationMutation<TContext>(options?: Omit<UseMutationOptions<boolean, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, void, TContext> {
  const key = toggleEnableObsidianIntegrationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.toggleEnableObsidianIntegration(),
    mutationKey: key,
  });
}